export default Object.freeze({ LOCAL_EXPANDED: 'localExpanded' });
